import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, as = "h2", className = "", onLoad = false, delay = 0, lineClass = "" }) => {
  const M = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <M
      className={className}
      initial="hidden"
      {...trigger}
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12, delayChildren: delay } } }}
    >
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hidden: { y: "115%" }, show: { y: "0%", transition: { duration: 1.15, ease: EASE } } }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </M>
  );
};
